import {useContext, useState} from "react";
import { motion } from "framer-motion";
import { dataContext } from "../../../context/context";
import Feedback from "../../feedback/feedback";
import Contact from "./contact";
import './contacts.css';
import {useMediaQuery} from "react-responsive";


function Contacts() {

    const { data  } = useContext(dataContext);
    const [showItems, setShowItems] = useState(false);
    const isMobile = useMediaQuery({ query: "(max-width: 1000px)" });

    return (
        <motion.section
            id="contacts"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true, amount: 0.5 }}
            transition={{ duration: 0.5, delay: 0.25 }}
            onAnimationComplete={() => {
                setShowItems(true);
            }}
        >
            { isMobile && (<h2 className="mobile-feedback">Готовы начать свой успешный бизнес?</h2>)}

            <div className="inner_block">

                <div className="feedback_column">
                    { !isMobile &&  (<h2>Готовы начать свой успешный бизнес?</h2>)}
                    { isMobile && (<h2>Отправьте заявку прямо сейчас</h2>)}

                    <Feedback />

                </div>
                <div className="contacts_column">

                    {
                        data.variablesdata.filter(variable => (variable.var === 'phone' || variable.var === 'address' || variable.var === 'email')).map((contact, index) => (
                            <motion.div
                                key={index}
                                initial={{ opacity: 0, x: 1000 }}
                                animate={ showItems ? { opacity: 1, x: 0 } : {}}
                                transition={{ delay: index * 0.1, duration: 0.5 }}
                                className="galery_item"
                            >
                            <Contact  key={index} nick={contact.var} title={contact.name} text={contact.val} clearedtext={contact.clearedval} />
                            </motion.div>
                        ))
                    }


                </div>
            </div>


        </motion.section>
    )
}

export default Contacts